"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getValue_1 = __importDefault(require("../utility/getValue"));
const __1 = require("..");
const SalesByCategoryData_1 = __importDefault(require("../entity/SalesByCategoryData"));
class SalesByCategoryDataStub extends SalesByCategoryData_1.default {
    constructor({ 
    // hourly = [
    //   new CategoryTimeSeriesDataStub({
    //     label: '2019-01',
    //     values: getValues({
    //       start: '2019-01-01T00:00:00',
    //       end: '2019-02-01T00:00:00',
    //       type: 'hours',
    //     }),
    //   }),
    //   new CategoryTimeSeriesDataStub({
    //     label: '2019-02',
    //     values: getValues({
    //       start: '2019-02-01T00:00:00',
    //       end: '2019-03-01T00:00:00',
    //       type: 'hours',
    //     }),
    //   }),
    // ],
    daily = [
        new __1.CategoryTimeSeriesDataStub({
            label: '2019-01',
            values: (0, getValue_1.default)({
                start: '2019-01-01T00:00:00',
                end: '2019-02-01T00:00:00',
                type: 'days',
            }),
        }),
        new __1.CategoryTimeSeriesDataStub({
            label: '2019-02',
            values: (0, getValue_1.default)({
                start: '2019-02-01T00:00:00',
                end: '2019-03-01T00:00:00',
                type: 'days',
            }),
        }),
    ], weekly = [
        new __1.CategoryTimeSeriesDataStub({
            label: '2019-01',
            values: (0, getValue_1.default)({
                start: '2019-01-01T00:00:00',
                end: '2019-01-08T00:00:00',
                type: 'days',
            }),
        }),
        new __1.CategoryTimeSeriesDataStub({
            label: '2019-02',
            values: (0, getValue_1.default)({
                start: '2019-01-09T00:00:00',
                end: '2019-01-16T00:00:00',
                type: 'days',
            }),
        }),
    ], monthly = [
        new __1.CategoryTimeSeriesDataStub({
            label: '2019-01',
            values: (0, getValue_1.default)({
                start: '2019-01-01T00:00:00',
                end: '2019-02-01T00:00:00',
                type: 'months',
            }),
        }),
        new __1.CategoryTimeSeriesDataStub({
            label: '2019-02',
            values: (0, getValue_1.default)({
                start: '2019-02-01T00:00:00',
                end: '2019-03-01T00:00:00',
                type: 'months',
            }),
        }),
    ], } = {}) {
        super({ daily, weekly, monthly });
    }
}
exports.default = SalesByCategoryDataStub;
